import { register } from '../component.js';
import 'react';

var _socialIcons_ravelry = register("ravelry", {"color":"#EE6E62","path":"M 0,0 H 64 V 64 H 0 Z m 42.692268,28.943187 c 0,0 -2.183968,-0.39738 -3.751944,-0.39738 -3.583932,0 -4.423932,1.986862 -4.423932,4.938744 v 12.48877 h -9.68784 v -25.43168 h 9.68784 v 4.257542 c 1.175992,-3.576324 3.527958,-4.825204 8.175876,-4.825204 z"});

export { _socialIcons_ravelry as default };
